import ModalAddEditTranslations from "./modal-add-edit-translations";

export default ModalAddEditTranslations;